/* eslint-disable no-unused-vars */
import { signIn } from 'next-auth/react';
import PropTypes from 'prop-types';
import React from 'react';
import { IoIosCar } from 'react-icons/io';
import { IoQrCode } from 'react-icons/io5';
import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Flex,
  Grid,
  Spinner,
  Text,
  ThemeProvider,
} from 'theme-ui';

import {
  CarDetailCard,
  CarPreviewWorkshopCard,
  FormModal,
  Layout,
  RefreshButton,
  SEO,
} from '../../../components';
import { STRINGS as COMMON_STRINGS } from '../../../constants';
import { STRINGS } from '../../../constants/workshop';
import theme from '../../../theme';
import styles from './CarsScreen.style';

const CarsScreen = (props) => {
  const {
    profile,
    logoutHandler,
    session,
    status,
    cars,
    isWorkshopOwnership,
    car,
    setCar,
    modalVisible,
    setModalVisible,
    modalFields,
    carActionHandler,
    createVisitHandler,
    currentVisitId,
    deleteCarHandler,
    isReady,
    isLoading,
    isRefreshing,
    isDetailsLoading,
    isModalLoading,
    setIsModalLoading,
    historyNavigator,
    onRefresh,
    onRefreshWithLoadingIndicator,
    onRefreshDetails,
    error,
  } = props;

  const renderCarsPanel = () => {
    if (cars.length > 0) {
      return (
        <Flex sx={styles.panelContainer}>
          {cars.map((item) => {
            return (
              <CarPreviewWorkshopCard
                key={item.id}
                item={item}
                action={setCar}
                active={item.id === car?.id}
              />
            );
          })}
        </Flex>
      );
    }
    if (!isWorkshopOwnership) {
      return (
        <Flex sx={styles.emptyPanelContainer}>
          <Text sx={styles.missingWorkshopOwnership}>{STRINGS.cars.missingWorkshopOwnership}</Text>
          <IoQrCode size={42} />
        </Flex>
      );
    }
    if (isLoading) {
      return (
        <Flex sx={styles.emptyPanelContainer}>
          <Spinner size={60} />
        </Flex>
      );
    }
    return (
      <Flex sx={styles.emptyPanelContainer}>
        <Flex sx={styles.emptyPanelTextContainer}>
          <Text sx={styles.emptyPanelTitle}>{STRINGS.cars.noCars}</Text>
          <Text sx={styles.emptyPanelText}>{STRINGS.cars.scanCarInAppDescription}</Text>
          <IoQrCode size={42} />
        </Flex>
      </Flex>
    );
  };

  const renderCarDetails = () => {
    if (car?.car) {
      return (
        <Flex sx={styles.carContainer}>
          <CarDetailCard
            item={car.car}
            visitId={car.visitId}
            createdAt={car.createdAt}
            ownershipId={car.id}
            startAction={carActionHandler}
            historyNavigator={historyNavigator}
            deleteCarHandler={deleteCarHandler}
          />
        </Flex>
      );
    }
    if (isDetailsLoading) {
      return (
        <Flex sx={styles.emptyPanelContainer}>
          <Spinner size={60} />
        </Flex>
      );
    }
    return (
      <Flex sx={styles.emptyPanelContainer}>
        <Flex sx={styles.emptyPanelTextContainer}>
          <Text sx={styles.emptyPanelTitle}>{STRINGS.cars.noCarDetailSelected}</Text>
          <IoIosCar size={42} />
        </Flex>
      </Flex>
    );
  };

  const renderForm = () => {
    return (
      <FormModal
        visible={modalVisible}
        setVisible={setModalVisible}
        fields={modalFields}
        title={STRINGS.cars.createVisitButtonText}
        action={createVisitHandler}
        actionText={STRINGS.visitDetail.startVisitText}
        isLoading={isModalLoading}
        isReady={isReady}
        setIsModalLoading={setIsModalLoading}
      >
        <CarPreviewWorkshopCard item={car} action={null} active />
      </FormModal>
    );
  };

  if (status === 'authenticated') {
    return (
      <ThemeProvider theme={theme}>
        <Layout>
          <SEO title={COMMON_STRINGS.seo.cars} />
          <Container sx={styles.container}>
            <RefreshButton onRefresh={onRefresh} isRefreshing={isRefreshing} />
            {renderForm()}
            <Grid sx={styles.grid}>
              <Card variant="carsCard">{renderCarsPanel()}</Card>
              <Card variant="carsCard">{renderCarDetails()}</Card>
            </Grid>
          </Container>
        </Layout>
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <SEO title={COMMON_STRINGS.seo.loading} />
        <Container sx={styles.container}>
          <Flex sx={styles.spinnerContainer}>
            <Spinner size={60} />
          </Flex>
        </Container>
      </Layout>
    </ThemeProvider>
  );
};

CarsScreen.propTypes = {
  cars: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  isReady: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isRefreshing: PropTypes.bool.isRequired,
  onRefresh: PropTypes.func.isRequired,
  onRefreshWithLoadingIndicator: PropTypes.func.isRequired,
  error: PropTypes.string,
};

CarsScreen.defaultProps = {
  cars: undefined,
  error: undefined,
};

export default CarsScreen;
